import { ThemeModule } from '../../front/lib/ThemeModule';
import { addLayoutResizeListener } from '../../front/lib/utils';
export class FactsBox extends ThemeModule {
    constructor() {
        super(...arguments);
        this.toggleBtnEl = this.getElementById('toggleBtn');
        this.wrapperEl = this.getElementById('wrapper');
        this.innerEl = this.getElementById('inner');
    }
    init() {
        this.toggleBtnEl.addEventListener('click', () => this.toggle());
        const adjustHeight = () => this.adjustHeight();
        addLayoutResizeListener(adjustHeight);
        this.addCleanupHandler(() => removeEventListener('layoutResize', adjustHeight));
        if (this.isOpen()) {
            this.open(false);
        }
        // Make sure the height is adjusted after any unaccounted style/layout changes
        const heightChecker = setInterval(() => {
            if (this.isOpen() && this.wrapperEl.offsetHeight !== this.innerEl.scrollHeight) {
                console.log(`Adjusting height`);
                this.adjustHeight();
            }
        }, 1000);
        this.addCleanupHandler(() => clearInterval(heightChecker));
    }
    adjustHeight() {
        this.wrapperEl.style.height = this.isOpen() ? `${this.innerEl.scrollHeight}px` : '';
    }
    open(transition = true) {
        this.withTransitionParam(transition, () => {
            this.root.classList.add('is--active');
            this.toggleBtnEl.setAttribute('aria-expanded', 'true');
            this.adjustHeight();
        });
    }
    close(transition = true) {
        this.withTransitionParam(transition, () => {
            this.root.classList.remove('is--active');
            this.toggleBtnEl.setAttribute('aria-expanded', 'false');
            this.wrapperEl.style.height = '';
        });
    }
    isOpen() {
        return this.root.classList.contains('is--active');
    }
    toggle(transition = true) {
        this.isOpen() ? this.close(transition) : this.open(transition);
    }
    withTransitionParam(transition, callback) {
        if (!transition) {
            this.wrapperEl.style.transition = 'none';
        }
        callback();
        if (!transition) {
            setTimeout(() => {
                this.wrapperEl.style.transition = '';
            });
        }
    }
}
